import {
  Box,
  CircularProgress,
  Paper,
  PaperProps,
  Stack,
  Typography,
} from '@mui/material';
import { memo, SyntheticEvent } from 'react';
import { CreateNewLabelButton } from './CreateNewLabelButton';

interface AutoCompletePaperProps {
  loading: boolean;
  selectionMode: 'reasons' | 'trackedKeywords';
  onCreateLabel: (event: SyntheticEvent) => void;
  baseProps: PaperProps;
  areReasonSuggestionsLoading: boolean;
}

export const AutoCompletePaper = memo(function AutoCompletePaper({
  baseProps,
  loading,
  selectionMode,
  onCreateLabel,
  areReasonSuggestionsLoading,
}: AutoCompletePaperProps) {
  const isLoading =
    loading || (areReasonSuggestionsLoading && selectionMode === 'reasons');

  return (
    <Paper {...baseProps}>
      {isLoading ? (
        <Stack justifyContent="center" alignItems="center" spacing={2} p={1}>
          <CircularProgress size={20} />
          <Typography color="text.secondary">
            {selectionMode === 'trackedKeywords'
              ? ' Loading Tracked Keywords...'
              : areReasonSuggestionsLoading
              ? 'Loading Reason Suggestions...'
              : 'Loading Reasons...'}
          </Typography>
        </Stack>
      ) : (
        <Box p={1.75}>
          <Typography color="text.secondary">
            {' '}
            {selectionMode === 'reasons'
              ? 'No Reasons found'
              : 'No Tracked Keywords found '}
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          position: 'sticky',
          bottom: 0,
          marginBottom: '0',
        }}
      >
        <Paper elevation={4}>
          <CreateNewLabelButton
            onCreateLabel={onCreateLabel}
            selectionMode={selectionMode}
          />
        </Paper>
      </Box>
    </Paper>
  );
});
